import { z } from "zod";

export const rsvpSubmissionSchema = z.object({
  name: z.string().trim().min(1).max(120),
  attendance: z.string().trim().min(1).max(40),
  guests: z.coerce.number().int().min(0).max(20)
});

export type RsvpSubmission = z.infer<typeof rsvpSubmissionSchema>;
